import { mapActions } from 'vuex'

const handover = {
  data() {
    return {
      countHandoverProtocols: this.$store.getters['handover/getCountHandovers'] || '-'
    }
  },
  computed: {
    handoverProtocolEnabled() {
      return this.$store.getters['user/getIsHandoverProtocolEnabled']
    }
  },
  watch: {
    handoverProtocolEnabled: {
      immediate: true,
      handler(enabled) {
        if (enabled === true) {
          this.getCountOverdueHandovers(true)
        }
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.getNumberInterval)
  },
  methods: {
    ...mapActions('handover', ['loadCountHandovers']),
    getCountOverdueHandovers(force = false) {
      if (this.$store.getters['user/getIsHandoverProtocolEnabled'] !== true) {
        return
      }
      this.$nextTick(async () => {
        this.countHandoverProtocols = await this.loadCountHandovers(force)
      })
    }
  }
}
export { handover }
